import { Sun } from "lucide-react";
import Reveal, { Eyebrow } from "./Reveal";
import { Wash, Sprig } from "./Watercolor";

const WORKSHOP_IMG =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_custom-umbrellas/artifacts/a4d787857c46edbb_IMG_3006.jpeg";
const MONOGRAM_IMG =
  "https://images.unsplash.com/photo-1774408130108-ce810972a641?crop=entropy&cs=srgb&fm=jpg&q=85";

export default function Bento() {
  return (
    <section id="why-us" className="relative py-24 sm:py-28" data-testid="bento-section">
      <Wash color="#FFD166" size={500} opacity={0.32} className="top-10 -left-40" />
      <Wash color="#F472B6" size={420} opacity={0.2} className="bottom-24 -right-36" />
      <Sprig color="#F9C5D5" className="hidden lg:block top-2 right-[5%] w-24" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Eyebrow>Why Ella's</Eyebrow>
          <h2 className="mt-4 font-serif font-medium tracking-tight text-ink text-3xl sm:text-4xl lg:text-5xl max-w-2xl">
            Small workshop, stubborn standards.
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-6 lg:grid-cols-12">
          <Reveal className="lg:col-span-8">
            <div className="group relative h-72 lg:h-80 overflow-hidden rounded-3xl">
              <img
                src={WORKSHOP_IMG}
                alt="The workshop bench"
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                data-testid="bento-workshop-image"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-ink/20 to-transparent" />
              <div className="absolute bottom-0 left-0 p-7 sm:p-9 max-w-md">
                <h3 className="font-serif text-2xl sm:text-3xl text-cream tracking-tight">
                  Painted by hand, never printed
                </h3>
                <p className="mt-2 text-sm text-cream/80 leading-relaxed">
                  Each canopy is stretched, sketched and painted by Ella herself — no two
                  umbrellas share a brushstroke.
                </p>
              </div>
            </div>
          </Reveal>

          <Reveal className="lg:col-span-4" delay={0.1}>
            <div className="h-full rounded-3xl border border-ink/10 bg-white p-7 sm:p-8">
              <Sun className="h-8 w-8 text-terracotta" />
              <h3 className="mt-5 font-serif text-xl sm:text-2xl tracking-tight">Rain & sun, one shield</h3>
              <p className="mt-2 text-sm leading-relaxed text-ink/65">
                Waterproof silk-touch canvas on top, a UV-50+ lining underneath. Built for
                April in all of its moods.
              </p>
            </div>
          </Reveal>

          <Reveal className="lg:col-span-12">
            <div className="flex flex-col sm:flex-row items-center gap-6 sm:gap-10 rounded-3xl bg-peach p-7 sm:p-8">
              <div className="h-44 w-full shrink-0 overflow-hidden rounded-2xl sm:w-72">
                <img
                  src={MONOGRAM_IMG}
                  alt="Monogram detail"
                  loading="lazy"
                  className="h-full w-full object-cover"
                  data-testid="bento-monogram-image"
                />
              </div>
              <div>
                <h3 className="font-serif text-xl sm:text-2xl tracking-tight">Your monogram, under the scallop</h3>
                <p className="mt-2 text-sm leading-relaxed text-ink/65">
                  Up to eight letters, hand-lettered inside the canopy in gold or moss ink.
                </p>
              </div>
            </div>
          </Reveal>

          <Reveal className="lg:col-span-12">
            <div
              className="flex flex-col sm:flex-row items-start sm:items-center gap-6 sm:gap-10 rounded-3xl bg-moss p-8 sm:p-10 text-cream"
              data-testid="bento-batch-stat"
            >
              <span className="font-serif text-6xl sm:text-7xl font-medium text-marigold">48</span>
              <p className="max-w-lg text-cream/85 leading-relaxed">
                umbrellas per batch — each one numbered by hand. Batch Nº 07 is on the bench
                right now, and roughly half of it already has a name on it.
              </p>
              <span className="sm:ml-auto font-mono text-[11px] uppercase tracking-[0.2em] text-marigold">
                Batch Nº 07 — Out now
              </span>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
